<template>
  <div class="country">
    <div class="banner"
      :style="{ backgroundImage: `url(https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/covers/${data?.attributes?.country.data.attributes.shortCode!}.jpg)` }">
      <div class="banner__mask"></div>
      <div class="banner__inner">
        <Breadcrumb :routes="routes" reversed-color />
        <div class="title">
          <h1>{{ data?.attributes?.country.data.attributes.cnName }}</h1>
          <a-button class="download" @click="onContactClick('下载指南')" type="primary">
            <img :src="downloadIcon" />
            下载指南
          </a-button>
        </div>
        <div class="infos">
          <div class="info">
            <label>货币: </label><span>{{ data?.attributes?.currency }}</span>
          </div>
          <div class="info">
            <label>首都: </label><span>{{ data?.attributes?.capital }}</span>
          </div>

          <div class="info">
            <label>官方语言: </label><span>{{ data?.attributes?.officialLanguage }}</span>
          </div>
          <div class="info">
            <label>薪资周期: </label><span>{{ data?.attributes?.payrollCycle }}</span>
          </div>
        </div>
        <div v-if="data?.attributes?.additional?.[6]?.attributes?.content" class="subtitle">
          <span class="text">{{ markdownToPlainText(data?.attributes?.additional?.[6]?.attributes?.content || '')
          }}</span>
          <nuxt-link class="more" :to="`/resource/global/${data?.attributes?.country?.data?.attributes?.name}/overview`">
            <span>查看更多</span>
          </nuxt-link>
        </div>
      </div>
      <div class="benefit_box">
        <div class="benefits-title">雇佣福利</div>
        <div class="benefits">
          <div class="benefits__item" v-for="(item, index) in data?.attributes?.benefits" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="content">
        <div class="title">雇佣指南</div>
        <div class="catalogue">
          <div :class="['catalogue-item', { activated: item.name === activeTab }]" v-for="item of data?.attributes.additional
            ?.map(item => ({
              name: item.attributes.category.data.attributes.name,
              text: item.attributes.category.data.attributes.title,
            }))
            .filter(el => employmentGuide.includes(el.text))" :key="item.name" @click="handlerClickCatalogue(item)">
            {{ item.text }}
          </div>
        </div>
        <div class="bar"></div>
        <div class="benefit_box_mobile">
          <div class="benefits-title">雇佣福利</div>
          <div class="benefits">
            <div class="benefits__item" v-for="(item, index) in data?.attributes?.benefits" :key="index">
              {{ item }}
            </div>
          </div>
        </div>
        <MobileEmploymentTools class="mobile-employment-tools" style="margin-top: 20px" />
        <Tabs :tabs="data?.attributes.additional?.map(item => ({
          name: item.attributes.category.data.attributes.name,
          text: item.attributes.category.data.attributes.title,
        }))
          " v-model="activeTab" class="tab" />
        <div class="detail_catalogue">
          <div class="policy_content">
            <div class="article-content markdown-content" v-for="(item, index) in data?.attributes.additional"
              :key="index" v-show="activeTab === item.attributes.category.data.attributes.name"
              v-html="marked.parse(item.attributes.content)"></div>
          </div>
        </div>
        <div class="downloadGuide">
          <a-button class="button" @click="onContactClick('下载指南')" type="primary">
            <img :src="downloadIcon" />
            下载指南
          </a-button>
        </div>
        <div style="padding: 0 30px; color: #4e5969" class="divider">
          <a-divider class="divider" orientation="center">继续查看当地雇佣信息</a-divider>
        </div>
        <div class="catalogue catalogue-bottom">
          <div :class="['catalogue-item', { activated: item.name === activeTab }]" v-for="item of data?.attributes.additional
            ?.map(item => ({
              name: item.attributes.category.data.attributes.name,
              text: item.attributes.category.data.attributes.title,
            }))
            .filter(el => employmentGuide.includes(el.text))" :key="item.name" @click="handlerClickCatalogue(item)">
            {{ item.text }}
          </div>
        </div>
      </div>
      <div class="side-tools">
        <div class="country_dynamics" v-show="relatedArticles?.length">
          <div class="static_title">国家动态</div>
          <nuxt-link v-for="(article, index) in relatedArticles?.slice(0, 5)" :key="article.id" class="dynamic"
            :to="`/info/${article.attributes.category.data.attributes.name}/${article.id}`">
            <span class="marking">{{ index + 1 }}</span>
            <span class="title-text">{{ article.attributes.title }}</span>
          </nuxt-link>
          <div class="more" @click="handlerMoreDynamics">查看更多</div>
        </div>
        <EmploymentTools class="employment-tools" :style="{ marginBottom: '20px' }" :country-code="country.shortCode"
          :country-name="country.name" />
        <!-- <ArticleRecommend /> -->
      </div>
    </div>
    <div class="employment-details">
      <div class="title">其他国家雇佣详情</div>
      <div class="country-list">
        <nuxt-link class="country" v-for="country in recommendCountry" :key="country.id"
          :to="`/resource/global/${country.attributes.country.data.attributes.name}`">
          <div class="hover_box">{{ country.attributes.country.data.attributes.cnName }}雇佣详情</div>
          <img class="country__cover"
            :src="`https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/covers/${country?.attributes?.country.data.attributes.shortCode}.jpg`" />
        </nuxt-link>
        <div class="more-country" @click="handleGoMoreCountry">
          <span>更多国家</span>
          <img src="@/assets/icons/arrow2.svg" alt="arrow2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IDetail, IEntity, IList } from '@/@types/cms';
import type { IArea, IArticle, IGlobalRecruitment } from '@/@types/entities';
import downloadIcon from '@/assets/icons/download-blue.svg';
import { marked } from 'marked';
import { ComputedRef } from 'vue';

const routes = [{ text: '资源中心' }, { text: '全球雇佣指南', path: '/resource/global' }, { text: '详情' }];

const router = useRouter();
const employmentGuide = ['工资和税收', '休假政策', '法定休假', '入职', '解雇', '合同'];
const countryList = ref<any[]>([]);

const result = await useAsyncData(async () => {
  const { data } = await useFetch<IList<IGlobalRecruitment>>(`/api/global/list`);
  const list = data.value?.data.map(item => ({
    ...item,
    url: `/resource/global/${item.attributes.country.data.attributes.name}`,
  }));
  const areaList = list?.reduce((res, item) => {
    const itemArea = item.attributes.area.data;
    if (res.findIndex(area => area.id === itemArea.id) < 0) {
      res.push(itemArea);
    }
    return res;
  }, [] as IEntity<IArea>[]);
  return {
    list,
    areaList,
  };
});

countryList.value = (result.data.value as any).list?.slice(0, 3);

const { countryName } = useRoute().params;
const { data } = await useAsyncData(async () => {
  const { data } = await useFetch<IDetail<IGlobalRecruitment>>(
    `/api/global/detail?countryName=${encodeURIComponent(countryName as string)}`
  );
  return data.value?.data;
});

// 请求国家推荐列表
const { data: countryResult } = await useAsyncData(async () => {
  const result = await useFetch<IList<IGlobalRecruitment>>(`/api/global/recommend-by-page?id=${data.value?.id || ''}`);
  return {
    data: result.data,
  };
});

// 推荐国家
const recommendCountry = computed(() => {
  return countryResult.value?.data || [];
}) as ComputedRef<any[]>;

if (!data.value?.id) {
  useLeadsInfo('下载更多国家资讯', 'freeDownload');
}

const { data: relatedArticles } = await useAsyncData(async () => {
  const { data: res } = await useFetch<IList<IArticle>>(
    `/api/article/list-by-country/?id=${data.value?.attributes?.country.data.id}`
  );
  return res.value?.data!;
});

const activeTab = ref(data.value?.attributes!.additional?.[0].attributes.category.data.attributes.name || '');

const {
  country: {
    data: { attributes: country },
  },
  tools,
} = data.value?.attributes as IGlobalRecruitment;

useSeoHead({
  title: country.cnName,
});

const handlerMoreDynamics = () => {
  router.push({
    path: '/info/guide',
  });
};

const handleGoMoreCountry = () => {
  router.push({
    path: '/resource/global',
  });
};

function onContactClick(entry: string) {
  useLeadsInfo(entry, 'unlock');
}

function handlerClickCatalogue(item: any) {
  activeTab.value = item.name;
  document.documentElement.scrollTop = 500;
}

const basicTools = [
  {
    img: 'https://video.reta-inc.com/image/default/597C3F7323DE472B83D35DD162D0FEAC-6-2.png',
    text: '雇佣成本计算器',
    url: `/resource/cost-calculator?countryCode=${country.shortCode}`,
  },
  {
    img: 'https://video.reta-inc.com/image/default/5F4C77B61E9E43DD87BDCFE3662DF8DE-6-2.png',
    text: '实得工资计算器',
    url: `/resource/wage-calculator?countryCode=${country.shortCode}`,
  },
  {
    img: 'https://video.reta-inc.com/image/default/F4550FF2313C4B53863E43D9C73B0A74-6-2.png',
    text: '薪酬洞察工具',
    url: `/resource/compensation-insight-tool?countryCode=${country.shortCode}`,
  },
];

// const advanceTools = [
//   {
//     category: 'labor_employment_regulations',
//     img: 'https://video.reta-inc.com/image/default/32CFD5934D0F4B58997F6DB999D3F823-6-2.png',
//     text: '全球劳动法',
//     url: `/resource/global/${country.name}/labor-employment-regulations`,
//   },
//   {
//     category: 'corporate_tax',
//     img: 'https://video.reta-inc.com/image/default/02F465ED831040EFB85E1DC73220F926-6-2.png',
//     text: '全球税收政策',
//     url: `/resource/global/${country.name}/corporate-tax`,
//   },
//   {
//     category: 'government_departments_relevant_institutions',
//     img: 'https://video.reta-inc.com/image/default/171FF58B756C47F29E3240F8ECD59182-6-2.png',
//     text: '全球政府机构',
//     url: `/resource/global/${country.name}/government-departments-relevant-institutions`,
//   },
//   {
//     category: 'banks_insurance_companies',
//     img: 'https://video.reta-inc.com/image/default/6DEB8DB2C1444410AB28BE805D88C5EB-6-2.png',
//     text: '全球银行保险机构',
//     url: `/resource/global/${country.name}/banks-insurance-companies`,
//   },
// ].filter(item => !!tools?.find(tool => tool.attributes.name === item.category));
// const toolList = [...basicTools, ...advanceTools];

function markdownToPlainText(markdown: string): string {
  // 首先删除所有标题和图片链接
  const noHeaderOrImage = markdown.replace(/^#+\s+.+|\n?!\[.*?\]\(.*?\)/gm, '');
  // 首先删除所有行首的 #，因为这是 Markdown 的标题标记
  const text = noHeaderOrImage.replace(/^#+\s*/gm, '');
  // 删除所有行首的 *、-、+，因为这是 Markdown 的列表标记
  const noList = text.replace(/^\s*([*-+])\s+/gm, '');
  // 将所有代码块中的内容视为纯文本，删除反引号
  const noCodeBlock = noList.replace(/`{3}[\s\S]*?`{3}/g, '');
  // 将所有内联代码中的内容视为纯文本，删除单个反引号
  const noInlineCode = noCodeBlock.replace(/`(.+?)`/g, '$1');
  // 将所有强调文本视为纯文本，删除星号或下划线
  const noEmphasis = noInlineCode.replace(/([*_])(.+?)\1/g, '$2');
  // 将所有链接和图像的描述文本视为纯文本，删除方括号和括号
  const noLinkText = noEmphasis.replace(/\[([^\]]+)\]\(.*?\)/g, '$1');
  // 将所有链接和图像的 URL 或路径视为纯文本，删除方括号和括号
  const noLinkUrl = noLinkText.replace(/!?\[[^\]]*\]\((.*?)\)/g, '$1');
  // 删除所有 HTML 标签，将其视为纯文本
  const noHtmlTags = noLinkUrl.replace(/<\/?[^>]+>/g, '');
  // 删除所有行末的空格
  const trimmed = noHtmlTags.replace(/[ \t]+$/gm, '');
  return trimmed;
}
</script>
<style lang="less" scoped>
.side-tools {
  margin-top: 100px;

  .country_dynamics {
    width: 330px;
    box-sizing: border-box;
    background: linear-gradient(180deg, rgba(255, 195, 162, 0.2) 0%, rgba(255, 195, 161, 0) 22.46%), #ffffff;
    border: 1px solid #e8f0ff;
    border-radius: 8px;
    padding: 24px;
    // border-radius: 4px;
    margin-bottom: 20px;

    .more {
      margin: 0 auto;
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 42px;
      background: #eff3fb;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #86909c;
      cursor: pointer;

      &:hover {
        color: #386aff;
      }
    }

    .static_title {
      font-weight: 500;
      font-size: 20px;
      line-height: 26px;
      letter-spacing: 0.01em;
      color: #1d2129;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }

    .dynamic {
      line-height: 24px;
      color: #4e5969;
      padding: 12px 0;
      text-decoration: none;
      display: flex;
      align-items: center;

      &:hover {
        color: #386aff;
      }

      .marking {
        width: 18px;
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 3px 8px;
        margin-right: 8px;
        background: #ff7d3c;
        border-radius: 2px;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        color: #ffffff;
      }

      .title-text {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    // .dynamic:not(:last-child) {
    //   border-bottom: 1px solid #e5e7eb;
    // }
  }
}

@media screen and (min-width: 800px) {
  .country {
    background-color: #eff3fb;
    padding-bottom: 100px;

    .main {
      display: flex;
      justify-content: center;
    }

    .content {
      max-width: 965px;
      // font-weight: 500;
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0.02em;
      color: #1d2129;

      .title {
        margin: 24px 44px;
        font-weight: 500;
        font-size: 20px;
        line-height: 32px;
        letter-spacing: 0.02em;
        color: #1d2129;
      }

      .catalogue {
        padding-bottom: 5px;
        margin: 24px 44px;
        display: flex;
        margin-top: 20px;
        gap: 10px;
        overflow-x: auto;

        .catalogue-item {
          white-space: nowrap;
          width: fit-content;
          padding: 8px 20px;
          cursor: pointer;
          font-size: 16px;
          line-height: 28px;
          letter-spacing: 0.02em;
          color: #4e5969;
          border: 1px solid #c9cdd4;
          border-radius: 8px;

          &:hover {
            color: #386aff;
            // background: rgba(22, 93, 255, 0.1);
          }

          &.activated {
            color: #386aff;
            background: rgba(22, 93, 255, 0.1);
            border: 0;
          }
        }
      }

      .catalogue-bottom {
        margin-top: 40px;
        justify-content: center;
      }

      .bar {
        margin-top: 24px;
        height: 2px;
        background: #eff3fb;

        :deep(.arco-divider-text) {
          color: #4e5969;
        }
      }
    }

    .employment-details {
      text-align: left;
      width: 1318px;
      margin: 0 auto;
      margin-top: 40px;

      .title {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 0.02em;
        color: #1d2129;
      }

      .country-list {
        display: flex;
        margin-top: 16px;
        width: 100%;
        gap: 15px;

        .country {
          display: flex;
          align-items: center;
          width: 270px;
          height: 120px;
          box-sizing: border-box;
          background: #ffffff;
          box-shadow: 0px 4px 16px rgba(135, 172, 255, 0.2);
          border-radius: 8px;
          box-sizing: border-box;
          overflow: hidden;
          text-decoration: none;
          position: relative;

          &__cover {
            width: 400px;
            height: 240px;
            display: block;
          }

          &__content {
            font-size: 20px;
            line-height: 26px;
            color: #1d2129;
            height: 60px;
            text-align: center;
            line-height: 60px;
          }

          &:hover {
            .country__content {
              color: #165dff;
            }
          }

          .hover_box {
            display: block;
            position: absolute;
            top: 0;
            bottom: 0;
            width: 100%;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
            height: 100%;
            border-radius: 12px;
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            letter-spacing: 0.02em;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;

            .go_detail {
              border: 1px solid #ffffff;
              border-radius: 24px;
              font-weight: 400;
              font-size: 20px;
              line-height: 26px;
              text-align: center;
              letter-spacing: 0.01em;
              color: #ffffff;
              background-color: transparent;
              padding: 12px 30px;
              cursor: pointer;
            }
          }
        }

        .more-country {
          cursor: pointer;
          writing-mode: tb;
          letter-spacing: 5px;
          width: 48px;
          height: 120px;
          background: #ffffff;
          border-radius: 8px;

          display: flex;
          justify-content: center;
          align-items: center;

          &:hover {
            color: #386aff;
          }
        }
      }
    }
  }

  .banner {
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    background-position: top center;
    padding-bottom: 50px;

    &__mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #052367;
      opacity: 0.4;
    }

    &__inner {
      position: relative;
      max-width: 1280px;
      padding: 24px 20px 28px;
      height: 100%;
      margin: 0 auto;

      .title {
        padding: 16px 0 0px;
        display: flex;

        .download {
          display: none !important;
        }

        & > h1 {
          font-weight: 600;
          font-size: 36px;
          line-height: 50px;
          color: #ffffff;
          margin: 0;
        }

        & > .arco-btn {
          margin-left: auto;
          display: flex;
          gap: 6px;
          padding: 0 24px;
          height: 48px;
        }
      }

      .subtitle {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .text {
          width: 1210px;
          font-size: 16px;
          line-height: 32px;
          color: #fff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .more {
          white-space: nowrap;
          cursor: pointer;
          font-size: 14px;
          line-height: 20px;
          color: #8eb1ff;
          text-decoration: none;
        }
      }

      .infos {
        display: flex;
        gap: 60px;
        margin-top: 20px;

        .info {
          flex-shrink: 0;
          font-size: 18px;
          line-height: 25px;
          color: #e5e7eb;
          display: flex;
          align-items: center;
          box-sizing: border-box;

          label {
            white-space: nowrap;
          }

          span {
            color: #fff;
            font-weight: 500;
            margin-left: 8px;
          }
        }
      }
    }

    .benefit_box {
      position: absolute;
      bottom: -100px;
      left: 0;
      right: 0;
      margin: 32px auto 24px;
      padding: 24px 0 24px 36px;
      max-width: 1280px;
      display: flex;
      flex-direction: column;
      background: linear-gradient(180deg, rgba(182, 206, 255, 0.2) 0%, rgba(188, 210, 255, 0) 22.46%), #ffffff;
      border: 1px solid #e8f0ff;
      border-radius: 8px;

      .benefits-title {
        font-weight: 500;
        font-size: 20px;
        line-height: 32px;
        letter-spacing: 0.02em;
        color: #1d2129;
      }

      .benefits {
        margin: 20px 0 0;
        display: flex;
        gap: 36px;

        &__item {
          padding-left: 32px;
          box-sizing: border-box;
          background-image: url('@/assets/icons/check-outline.svg');
          background-repeat: no-repeat;
          background-position: 0 8px;
          background-size: 18px;
          font-size: 20px;
          line-height: 32px;
          color: #000;
        }
      }
    }
  }

  .content {
    box-sizing: border-box;
    background: linear-gradient(179.89deg, rgba(222, 255, 229, 0.2) 0.1%, rgba(188, 210, 255, 0) 6.08%), #ffffff;
    border: 1px solid #e8f0ff;
    border-radius: 8px;
    max-width: 975px;
    margin-top: 100px;
    margin-right: 24px;

    .tab,
    .benefit_box_mobile,
    .mobile-employment-tools {
      display: none;
    }

    .hire_tools {
      padding-bottom: 40px;
      border-bottom: 1px solid #e4e6e9;

      .tool_title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        color: #1d2129;
      }

      .tools {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
        gap: 24px;

        .item_entry {
          text-decoration: none;
          width: 236px;
          height: 80px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #ffffff;
          box-shadow: 0px 2px 16px rgba(135, 172, 255, 0.2);
          border-radius: 4px;
          background-repeat: no-repeat;
          background-size: 32px 32px;
          background-position: left 10px center;

          .text {
            max-width: 140px;
            margin-left: 50px;
            margin-right: 7px;
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            color: #1d2129;
          }

          .icon {
            width: 28px;
            height: 28px;
            margin-right: 8px;
          }
        }
      }
    }

    .detail_catalogue {
      padding: 0 44px;
      display: flex;

      .policy_content {
        width: 910px;
      }

      .catalogue {
        margin-left: auto;
        background-color: #fff;
        width: 300px;
        height: fit-content;
        position: sticky;
        top: 120px;
      }
    }

    .downloadGuide {
      display: flex;
      justify-content: center;
      padding: 40px 0;

      .button {
        width: 200px;
        height: 48px;
      }
    }

    .tabs {
      margin-top: 60px;
    }

    :deep(& > .arco-select-view-single) {
      display: flex;
      margin: 40px 20px 0;
      width: auto;
      height: 60px;
      background: #fff;
      border: 1px solid rgb(229, 230, 232);

      .arco-select-view-value {
        font-size: 20px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 800px) {
  .main {
    .side-tools {
      margin-top: 10px;

      .country_dynamics {
        // width: 340px;
        width: auto;
        margin: 0 16px;
        margin-bottom: 20px;
        border: 1px solid #f2f3f5;
      }

      .employment-tools {
        display: none;
      }
    }

    .downloadGuide {
      display: flex;
      justify-content: center;
    }

    .divider {
      display: none;
    }
  }

  .banner {
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    background-position: top center;

    &__mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #052367;
      opacity: 0.4;
    }

    &__inner {
      position: relative;
      // max-width: 1280px;
      padding: 24px 20px 28px;
      height: 100%;
      margin: 0 auto;

      .title {
        padding: 18px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(229, 231, 235, 0.5);

        & > h1 {
          font-weight: 600;
          font-size: 18px;
          line-height: 25px;
          color: #ffffff;
          margin: 0;
        }

        & > .arco-btn {
          margin-left: auto;

          & + .arco-btn {
            margin-left: 24px;
          }
        }
      }

      .subtitle {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0.02em;
        color: #ffffff;
        margin-top: 16px;

        .text {
          display: -webkit-box;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .more {
          white-space: nowrap;
          cursor: pointer;
          font-size: 14px;
          line-height: 20px;
          color: #8eb1ff;
          text-decoration: none;
        }
      }

      .infos {
        display: grid;
        grid-template-columns: auto auto;
        grid-template-rows: auto auto;
        row-gap: 6px;
        margin-top: 20px;

        .info {
          // width: 296px;
          // height: 80px;
          flex-shrink: 0;
          // background: #ffffff;
          // box-shadow: 0px 2px 16px rgba(135, 172, 255, 0.2);
          // border-top-right-radius: 8px;
          // border-bottom-right-radius: 8px;
          line-height: 20px;
          color: #e5e7eb;
          display: flex;
          align-items: center;
          // padding-left: 28px;
          box-sizing: border-box;
          // margin-bottom: 32px;

          label {
            white-space: nowrap;
          }

          span {
            color: #fff;
            font-weight: 500;
            margin-left: 8px;
          }

          // &:nth-child(1) {
          //   border-left: 4px solid #165dff;
          // }

          // &:nth-child(2) {
          //   border-left: 4px solid #ffa189;
          // }

          // &:nth-child(3) {
          //   border-left: 4px solid #ad92ff;
          // }

          // &:nth-child(4) {
          //   border-left: 4px solid #ffd687;
          // }
        }
      }
    }
  }

  .benefit_box {
    display: none;
  }

  .content {
    margin: 20px auto 40px;

    .title {
      display: none;
    }

    .catalogue {
      display: none;
    }

    .hire_tools {
      .tool_title {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #1d2129;
        text-align: center;
      }

      .tools {
        padding: 16px 16px 24px;
        display: grid;
        gap: 12px;
        grid-template-columns: 1fr 1fr;

        .item_entry {
          text-decoration: none;
          height: 48px;
          display: flex;
          align-items: center;
          background: #ffffff;
          box-shadow: 0px 2px 16px rgba(135, 172, 255, 0.2);
          border-radius: 4px;
          background-repeat: no-repeat;
          background-size: 24px 24px;
          background-position: left 12px center;

          .text {
            margin-left: 44px;
            // margin-right: 8px;
            font-weight: 500;
            line-height: 20px;
            color: #1d2129;
          }

          .icon {
            width: 28px;
            height: 28px;
            margin-right: 8px;
            display: none;
          }
        }
      }
    }

    .benefit_box_mobile {
      margin: 0 16px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      background: #f5f8ff;
      opacity: 0.9;
      border-radius: 4px;

      .benefits-title {
        font-weight: 500;
        line-height: 20px;
        color: #1d2129;
      }

      .benefits {
        margin: 12px 0 0;
        display: flex;
        flex-wrap: wrap;
        row-gap: 8px;
        column-gap: 16px;

        &__item {
          padding-left: 22px;
          box-sizing: border-box;
          background-image: url('@/assets/icons/check-outline.svg');
          background-repeat: no-repeat;
          background-position: 0 4px;
          background-size: 14px;
          line-height: 20px;
          color: #000;
          white-space: nowrap;
        }
      }
    }

    :deep(.container) {
      position: sticky;
      top: 70px;
      background-color: #fff;

      .tabs {
        gap: 0;
        padding-left: 0;

        .tab {
          padding-left: 16px;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          -webkit-tap-highlight-color: transparent;
          outline: none;
          background: none;
          text-decoration: none;

          &::after {
            width: calc(100% - 16px);
            right: 0;
            left: unset;
          }

          &:focus-visible,
          &:active {
            background: transparent;
            outline: none;
          }
        }
      }

      .active {
        font-weight: 500;
      }
    }

    .tabs {
      margin: 26px 16px 0;
      height: auto;
      background: #fff;
      z-index: 10;
      overflow-x: auto;
      position: sticky;
      top: 70px;
      border-bottom: 1px solid #eee;

      :deep(.tab) {
        white-space: nowrap;
        padding: 6px 12px;
        display: inline-block;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        letter-spacing: 0.02em;

        &:active {
          font-weight: 500;
        }
      }

      &.active {
        color: #386aff;
        background: rgba(22, 93, 255, 0.1);

        &:after {
          content: ' ';
          display: block;
          position: absolute;
          height: 3px;
          left: 0;
          bottom: 0;
          width: 100%;
          background: #165dff;
        }
      }
    }

    .tabs::-webkit-scrollbar {
      display: none;
    }

    .detail_catalogue {
      padding: 0 16px;
      margin-top: 20px;

      .catalogue {

        // padding: 16px;
        .country_dynamics {
          padding: 24px;
          margin-top: 60px;
          background: linear-gradient(180deg, #f6f9ff 0%, #f6f9ff 100%);
          border-radius: 4px;

          .static_title {
            font-weight: 500;
            font-size: 20px;
            line-height: 26px;
            letter-spacing: 0.01em;
            color: #1d2129;
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            // &::before {
            //   content: '';
            //   display: inline-block;
            //   width: 4px;
            //   height: 20px;
            //   background: #165dff;
            //   margin-right: 12px;
            // }
          }

          .dynamic {
            line-height: 24px;
            color: #4e5969;
            padding: 12px 0;
            text-decoration: none;
            display: block;
          }

          // .dynamic:not(:last-child) {
          //   border-bottom: 1px solid #e5e7eb;
          // }
        }

        .employment-tools {
          width: 336px;
        }
      }
    }

    :deep(.policy-content) {
      padding: 21px 0 44px;
      word-wrap: break-word;

      section {
        margin: 0;
        padding: 0 16px;
      }

      section:nth-child(n + 2) {
        margin-top: 40px;
      }
    }

    :deep(& > .arco-select-view-single) {
      display: flex;
      margin: 40px 20px 0;
      width: auto;
      height: 60px;
      background: #fff;
      border: 1px solid rgb(229, 230, 232);

      .arco-select-view-value {
        font-size: 20px;
      }
    }

    .catalogues {
      display: none;
    }
  }

  .employment-details {
    display: none;
  }
}
</style>
